import * as React from 'react';
import { useMsgText } from '../localization/hooks';
import { Str } from '../localization/translationKeys';
import { removeRedundantBackslashes } from '../localization/removeRedundantBackslashes';
import { css } from '@emotion/core';
import { COLORS } from '../globalStyle/colors';
import { useBrowser } from '../language/useBrowser';
import { makeRoutes } from '../navigation/routes';
import { FLEX_ROW, FLEX_COLUMN } from '../layout/flexBox';


type StatementProps = {
  className?: string;
  titleKey: string;
  bodyKey: string;
  title: string;
  srcPage: string;
}


const styles = {
  parent: [
    FLEX_COLUMN,
    css`
      align-items: flex-start;
      width: 100vw;
      height: 100vh;
      overflow: hidden;
    `,
  ],
  header: [
    FLEX_ROW,
    css`
      flex-grow: 1;
      font-weight: normal;
      color: ${COLORS.DARK_GREY};
      padding: 0 8px;
    `,
  ],
  iframe: css`
    width: 100%;
    height: 100vh;
  `,
};


/**
 * LegalStatement: a component that renders a full-page legal statement with title.
 *
 * PureComponent: true
 * Connected to Redux: true
 */
const Statement: React.FC<StatementProps> = props => {
  const header        = useMsgText(props.titleKey);
  const rawContent    = useMsgText(props.bodyKey);
  const body          = removeRedundantBackslashes(rawContent);
  const headerElement = <h1 css={styles.header}>{header}</h1>;
  const { onIe }       = useBrowser();

  return (
    <div css={styles.parent}>
      {headerElement}
      <iframe
        frameBorder={0}
        css={styles.iframe}
        srcDoc={onIe ? undefined : body}
        src={onIe ? props.srcPage : undefined}
        title={props.titleKey}
      />
    </div>
  );
};


type Props = {
  className?: string;
}

const routes = makeRoutes();

export const CopyrightStatement = (props: Props) => (
  <Statement
    className={props.className}
    titleKey={Str.Copyright}
    bodyKey={Str.CopyrightText}
    title='privacy-text-body'
    srcPage={routes.CopyrightStatic}
  />
);


export const PrivacyStatement = (props: Props) => (
  <Statement
    className={props.className}
    titleKey={Str.PrivacyPolicy}
    bodyKey={Str.PrivacyText}
    title='copyright-text-body'
    srcPage={routes.PrivacyStatic}
  />
);
